import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    MultiSelectBox,
    SearchDateBox,
    SearchBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import TaroffOrdersPeikSetInit from '../peik/TaroffOrdersPeikSetInit';
import TaroffOrdersPeikConfirmOrder from '../peik/TaroffOrdersPeikConfirmOrder';
import TaroffOrdersView from '../orders/TaroffOrdersView';
import { postData } from '../../Api';

export default function TaroffOrdersPeikDelivered(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-delivered/select-data/q-shop-id').then(
            (response) => {
                setFormQShopIdOptions(response.data);
            }
        );
    }, []);
    const [formQShiftIdOptions, setFormQShiftIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-delivered/select-data/q-shift-id').then(
            (response) => {
                setFormQShiftIdOptions(response.data);
            }
        );
    }, []);
    const [formQDeliverTimeIdOptions, setFormQDeliverTimeIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-delivered/select-data/q-deliver-time-id').then(
            (response) => {
                setFormQDeliverTimeIdOptions(response.data);
            }
        );
    }, []);
    const handlecomp1 = () => {
        applyFilters();
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQId('');
        setFilterQShopCode('');
        setFilterQShopId('');
        setFilterQTitle('');
        setFilterQInsertTimeFrom('');
        setFilterQInsertTimeTo('');
        setFilterQShiftId('');
        setFilterQDeliverTimeId('');
        setFilterQCustomerName('');
        setFilterQCustomerMobile('');
        setFilterQAddress('');
        setFilterQPostCode('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQId && (newSearchParams['q-id'] = filterQId);
        filterQShopCode && (newSearchParams['q-shop-code'] = filterQShopCode);
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        filterQInsertTimeFrom && (newSearchParams['q-insert-time-from'] = filterQInsertTimeFrom);
        filterQInsertTimeTo && (newSearchParams['q-insert-time-to'] = filterQInsertTimeTo);
        filterQShiftId && (newSearchParams['q-shift-id'] = filterQShiftId);
        filterQDeliverTimeId && (newSearchParams['q-deliver-time-id'] = filterQDeliverTimeId);
        filterQCustomerName && (newSearchParams['q-customer-name'] = filterQCustomerName);
        filterQCustomerMobile && (newSearchParams['q-customer-mobile'] = filterQCustomerMobile);
        filterQAddress && (newSearchParams['q-address'] = filterQAddress);
        filterQPostCode && (newSearchParams['q-post-code'] = filterQPostCode);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQId, setFilterQId] = useState(allProps['q-id'] || '');
    const [filterQShopCode, setFilterQShopCode] = useState(allProps['q-shop-code'] || '');
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    const [filterQInsertTimeFrom, setFilterQInsertTimeFrom] = useState(
        allProps['q-insert-time-from'] || ''
    );
    const [filterQInsertTimeTo, setFilterQInsertTimeTo] = useState(
        allProps['q-insert-time-to'] || ''
    );
    const [filterQShiftId, setFilterQShiftId] = useState(allProps['q-shift-id'] || '');
    const [filterQDeliverTimeId, setFilterQDeliverTimeId] = useState(
        allProps['q-deliver-time-id'] || ''
    );
    const [filterQCustomerName, setFilterQCustomerName] = useState(
        allProps['q-customer-name'] || ''
    );
    const [filterQCustomerMobile, setFilterQCustomerMobile] = useState(
        allProps['q-customer-mobile'] || ''
    );
    const [filterQAddress, setFilterQAddress] = useState(allProps['q-address'] || '');
    const [filterQPostCode, setFilterQPostCode] = useState(allProps['q-post-code'] || '');
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik-delivered/table-data', {
            size: tableSize,
            page: tablePage,
            q_id: filterQId,
            q_shop_code: filterQShopCode,
            q_shop_id: filterQShopId,
            q_title: filterQTitle,
            q_insert_time_from: filterQInsertTimeFrom,
            q_insert_time_to: filterQInsertTimeTo,
            q_shift_id: filterQShiftId,
            q_deliver_time_id: filterQDeliverTimeId,
            q_customer_name: filterQCustomerName,
            q_customer_mobile: filterQCustomerMobile,
            q_address: filterQAddress,
            q_post_code: filterQPostCode,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp2 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersPeikConfirmOrder
                        taroff-orders-id={row.param_id}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp3 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersView
                        taroff-orders-id={row.param_id_2}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp4 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersPeikSetInit
                        taroff-orders-id={row.param_id_3}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    return (
        <PanelBox>
            <Title>سفارشات تحویل شده</Title>
            <SearchBox onEnter={applyFilters} label={'شناسه'} value={filterQId} onChange={setFilterQId} width={'120px'} />
            <SearchBox onEnter={applyFilters}
                label={'کد رهگیری در فروشگاه'}
                value={filterQShopCode}
                onChange={setFilterQShopCode}
                width={'120px'}
            />
            <MultiSelectBox
                label={'فروشگاه'}
                options={formQShopIdOptions}
                value={filterQShopId}
                onChange={setFilterQShopId}
            />
            <SearchBox onEnter={applyFilters}
                label={'عنوان'}
                value={filterQTitle}
                onChange={setFilterQTitle}
                width={'120px'}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان درج از'}
                value={filterQInsertTimeFrom}
                onChange={setFilterQInsertTimeFrom}
                width={'100px'}
            />
            <SearchDateBox onEnter={applyFilters}
                label={'زمان درج تا'}
                value={filterQInsertTimeTo}
                onChange={setFilterQInsertTimeTo}
                width={'100px'}
            />
            <MultiSelectBox
                label={'شیفت های پیک تعارف'}
                options={formQShiftIdOptions}
                value={filterQShiftId}
                onChange={setFilterQShiftId}
            />
            <MultiSelectBox
                label={'زمان ارسال'}
                options={formQDeliverTimeIdOptions}
                value={filterQDeliverTimeId}
                onChange={setFilterQDeliverTimeId}
            />
            <SearchBox onEnter={applyFilters}
                label={'نام خریدار'}
                value={filterQCustomerName}
                onChange={setFilterQCustomerName}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'همراه خریدار'}
                value={filterQCustomerMobile}
                onChange={setFilterQCustomerMobile}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'آدرس'}
                value={filterQAddress}
                onChange={setFilterQAddress}
                width={'120px'}
            />
            <SearchBox onEnter={applyFilters}
                label={'کد پستی'}
                value={filterQPostCode}
                onChange={setFilterQPostCode}
                width={'120px'}
            />
            <Button onClick={handlecomp1} color={'secondary'}>
                جستجو
            </Button>
            <RightComponents wrap={true}>
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>ردیف</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>نام خریدار</TableColumn>
                        <TableColumn mobile={false}>مبلغ سفارش</TableColumn>
                        <TableColumn mobile={false}>مبلغ قابل پرداخت</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}> </TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_shop_id_title}</TextView>
                                <RightComponents>
                                    <TextView>{row.text_title}</TextView>
                                    <TextView>{row.text}</TextView>
                                    <TextView>{row.text_shop_code}</TextView>
                                </RightComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView>{row.text_customer_name}</TextView>
                                    <TextView>{row.text_2}</TextView>
                                    <TextView>{row.text_customer_mobile}</TextView>
                                </RightComponents>
                                <TextView>{row.text_address}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'money'}>{row.text_payable_price}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'money'}>{row.text_payable_price_2}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView backColor={row.color_state_id_color} bold={true}>
                                    {row.text_state_id_title}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <LeftComponents>
                                    <Button
                                        onClick={() => handlecomp2(row)}
                                        rightIcon={'far fa-check-double'}
                                        tooltip={'تایید مالی'}
                                    ></Button>
                                    <Button
                                        onClick={() => handlecomp3(row)}
                                        rightIcon={'far fa-info'}
                                        tooltip={'Taroff Orders View'}
                                    ></Button>
                                    <Button
                                        onClick={() => handlecomp4(row)}
                                        rightIcon={'fal fa-undo'}
                                        tooltip={'در انتظار تایید'}
                                    ></Button>
                                </LeftComponents>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
